import { render } from "./TissuCreate.vue?vue&type=template&id=503b666a"
import script from "./TissuCreate.vue?vue&type=script&lang=js"
export * from "./TissuCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__